import {
	Carousel,
	CarouselContent,
	CarouselItem,
} from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
import usePlans from "../hooks/use-plans";
import { Plan } from "../models/plan";
import { Subscription } from "../models/subscription";
import PlanCard from "../components/plan-card";

function PlanSelection({
	header,
	footer,
	className,

	selectedPlan,
	currentSubscription,
	currentPlan,
	onPlanSelected,
}: {
	header?: React.ReactNode;
	footer?: React.ReactNode;
	className?: string;
	selectedPlan?: Plan | null;
	currentSubscription?: Subscription | null;
	currentPlan?: Plan | null;
	onPlanSelected: (plan: Plan) => void;
}) {
	const { setApi, plans, current, goTo } = usePlans();

	return (
		<div className={cn("flex w-full flex-col gap-8 py-2 md:gap-16", className)}>
			{header}
			<Carousel setApi={setApi} className="md:hidden">
				<CarouselContent className="ml-0">
					{plans.map((plan, index) => (
						<CarouselItem key={index} className="px-4 py-4">
							<PlanCard
								currentSubscription={currentSubscription}
								currentPlan={currentPlan}
								plan={plan}
								plansCount={plans.length}
								selectedPlanId={selectedPlan?.id}
								onSelect={onPlanSelected}
								isRecommended={index === Math.floor(plans.length / 2)}
							/>
						</CarouselItem>
					))}
				</CarouselContent>
			</Carousel>

			<div className="flex items-center justify-center gap-2 md:hidden">
				{Array.from({ length: plans.length }).map((_, index) =>
					current === index + 1 ? (
						<div
							key={index}
							onClick={() => goTo(index)}
							className={`h-3 w-3 rounded-full bg-blue-700 transition-all duration-300`}
						></div>
					) : (
						<div
							key={index}
							onClick={() => goTo(index)}
							className={`bg-blue-900-20 h-2 w-2 rounded-full transition-all duration-300`}
						></div>
					)
				)}
			</div>

			<div className="bg-light relative flex flex-row items-start justify-around gap-6 rounded-[32px] p-4 pt-8 max-sm:hidden">
				{plans.map((plan, index) => (
					<PlanCard
						key={index}
						currentSubscription={currentSubscription}
						currentPlan={currentPlan}
						plan={plan}
						plansCount={plans.length}
						selectedPlanId={selectedPlan?.id}
						onSelect={onPlanSelected}
						isRecommended={index === Math.floor(plans.length / 2)}
					/>
				))}
			</div>

			{footer}
		</div>
	);
}

export default PlanSelection;
